// Spring answers an abort inside a controller with `ResponseStatusException`, whose
// `getMessage()` is serialised verbatim into `response.data.message`:
//
//   500 INTERNAL_SERVER_ERROR "An internal server error occurred
//   Patient has not set SMS as a communication preference"
//
// Shown as-is, a receptionist reads a status code, a quote mark and a line that says
// nothing before reaching the one sentence they can act on. Only that last line is
// addressed to them; the rest is transport.
const STATUS_PREFIXED = /^\d{3}\s+[A-Z_]+\s+"([\s\S]*)"$/;

/**
 * The human sentence inside a server error message, without the status wrapper.
 *
 * Anything that isn't in that shape is returned untouched — this narrows a known
 * serialisation, it does not guess at arbitrary text.
 */
export const stripTransportNoise = (message) => {
  if (typeof message !== "string" || !message.trim()) return message;

  const match = STATUS_PREFIXED.exec(message.trim());
  const lines = (match ? match[1] : message)
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  return lines[lines.length - 1] || message;
};
